import type { ToggleSidebarActionType } from 'actions/sidebar/types';

export const TOGGLE_SIDEBAR: ToggleSidebarActionType =
  '@@app/sidebar/TOGGLE_SIDEBAR';
